import EntityList from "../../components/EntityList"
import { useTranslation } from "react-i18next"
import { useIsMobile } from "../../hooks/useMediaQuery"

export default function RoleList() {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const columns = [
    { id: "id", label: t("fields.id"), minWidth: 50, hide: isMobile }, // técnico — some no mobile
    { id: "name", label: t("fields.name"), minWidth: 170 },
  ]
  return <EntityList title={t("roles.listTitle")} endpoint="/role" columns={columns} addPath="/role/new" editPathPrefix="/role" />
}
